import Vue from 'vue'
import { GET_EDUCATION_LEVELS } from '../mutation-types.js'

export const getEducationLevels = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('education_level')
    .then(
      (response) => {
        dispatch(GET_EDUCATION_LEVELS, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/educationLevelsActions.js